export interface Reference {
  no: number;
  document: string;
  publisher: string;
  category: string;
  edition: string;
  status: string;
  notes: string;
  remarks: string;
  preview: string;
}

export const CONTENT: Reference[] = [
  {
    no: 1,
    document: 'Agreement And Conditions Of PAM Contract 2018 (With Quantities)',
    publisher: 'PAM',
    category: 'Forms of Contract',
    edition: '2018',
    status: 'Effective',
    notes: 'Effective',
    remarks:
      'Standard private-sector contract with detailed quantities, defining obligations, payments, and dispute resolution for building projects.',
    preview:
      'https://drive.google.com/file/d/14V8oyWec2YA6aPFW4TxmEZQ17gg16pmz/view?usp=sharing',
  },
  {
    no: 2,
    document:
      'Agreement And Conditions Of PAM Contract 2018 (Without Quantities)',
    publisher: 'PAM',
    category: 'Forms of Contract',
    edition: '2018',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Private-sector contract without detailed quantities, clarifying responsibilities, payments, and legal compliance.',
    preview:
      'https://drive.google.com/file/d/10kA3w0Pr4oJ7F2kHjtLRXYfNqUeBgePN/view?usp=sharing',
  },
  {
    no: 3,
    document: 'Agreements and Conditions of PAM Sub-Contract 2018',
    publisher: 'PAM',
    category: 'Forms of Contract',
    edition: '2018',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Standard form for subcontracting under PAM contracts, outlining roles, obligations, and dispute resolution.',
    preview:
      'https://drive.google.com/file/d/1Q0uRWLnnjksfnaxO8uUXveF2E8eOcGdU/view?usp=sharing',
  },
  {
    no: 4,
    document: 'Arbitration (Amendment) Act 2024 (Act A1737)',
    publisher: 'LAM',
    category: 'Legislative',
    edition: '2024',
    status: 'Pending',
    notes: 'Archived',
    remarks: 'An Act to amend the Arbitration Act 2005.',
    preview:
      'https://drive.google.com/file/d/1GhCWEvFx-2OQY8_Y-eSSOKP_E2_Wil2U/view?usp=sharing',
  },
  {
    no: 5,
    document: 'Arbitration Act 2005 (Act 646)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2018',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to reform the law relating to domestic arbitration, provide for international arbitration, the recognition and enforcement of awards and for related matters.',
    preview:
      'https://drive.google.com/file/d/1PXPQc-BeaJY_yL122h99HwOJM7q0jvza/view?usp=sharing',
  },
  {
    no: 6,
    document: 'Architects Act 1967 (Act 117)',
    publisher: 'LAM',
    category: 'Legislative',
    edition: '2015',
    status: 'Archived',
    notes: 'Archived',
    remarks:
      'An Act to provide for the registration of architects, sole proprietorships, partnerships and bodies corporate providing architectural consultancy services, interior designers and building draughtsmen.',
    preview:
      'https://drive.google.com/file/d/1ulk5VScfx2BPHQj7SiZ3yHT5NdyicjBh/view?usp=sharing',
  },
  {
    no: 7,
    document: 'BCISM Costbook 2024',
    publisher: 'BCISM',
    category: 'Costbook',
    edition: '2024',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'This publication offers a concise and reliable guide to current construction costs in Malaysia, based on actual data collected and analysed. It is regularly updated to reflect the latest market conditions and trends, serving as a vital resource for professionals in the construction industry.',
    preview:
      'https://drive.google.com/file/d/1Cfs5p05ZHR65ylER5exUFPj-bkdSm3tD/view?usp=sharing',
  },
  {
    no: 8,
    document:
      'CIDB Standard Form of Contract for Building Works 2022 Edition - CIDB SFC Building Works 2022',
    publisher: 'CIDB',
    category: 'Forms of Contract',
    edition: '2022',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Provides a standardized contract framework for building projects, ensuring legal compliance, clear roles, and structured payments for contractors under CIDB regulations.',
    preview:
      'https://drive.google.com/file/d/18OsLcd8PxEpzrzzAJveORoDyYSmFEmtw/view?usp=sharing',
  },
  {
    no: 9,
    document: 'Companies Act 2016 (Act 777)',
    publisher: 'Attorney General’s Chambers of Malaysia',
    category: 'Legislative',
    edition: '2022',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to provide for the registration, administration and dissolution of companies and corporations and to provide for related matters.',
    preview:
      'https://drive.google.com/file/d/1SJpUO9P4dNi7dWKtTinpQcrA1Ab_PGg2/view?usp=sharing',
  },
  {
    no: 10,
    document: 'Conditions of Contract for Construction - FIDIC Red Book 2017',
    publisher: 'FIDIC',
    category: 'Forms of Contract',
    edition: '2017',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Used internationally for construction works designed by the employer, outlining obligations, risk allocation, and dispute resolution in line with best practices.',
    preview:
      'https://drive.google.com/file/d/1pawIvqq-SO5zgS1QEPqu41OzStbunQou/view?usp=sharing',
  },
  {
    no: 11,
    document:
      'Conditions of Contract for EPC/Turnkey Projects - FIDIC Silver Book 2017',
    publisher: 'FIDIC',
    category: 'Forms of Contract',
    edition: '2017',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Governs EPC/Turnkey projects, assigning design and construction responsibilities to contractors with clear risk and performance provisions.',
    preview:
      'https://drive.google.com/file/d/1ltqTAzZgEYlwcGH-twJCiWH-j4A47cnX/view?usp=sharing',
  },
  {
    no: 12,
    document:
      'Conditions of Contract for Plant and Design Build - FIDIC Yellow Book 2017',
    publisher: 'FIDIC',
    category: 'Forms of Contract',
    edition: '2017',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Standard contract for design-and-build projects, specifying contractor design responsibility, obligations, and delivery requirements.',
    preview:
      'https://drive.google.com/file/d/1Dj5jcpipckXEC35S_Urcc1JYOHAX7ldJ/view?usp=sharing',
  },
  {
    no: 13,
    document:
      'Construction Industry Payment and Adjudication Act 2012 (Act 746)',
    publisher: 'PNMB',
    category: 'Legislative',
    edition: '2012',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to facilitate regular and timely payment, to provide a mechanism for speedy dispute resolution through adjudication, to provide remedies for the recovery of payment in the construction industry and to provid for connected and incidental matters.',
    preview:
      'https://drive.google.com/file/d/18PYZ5-2xSPnx7psf5FzjV7APyr4FDZ2M/view?usp=sharing',
  },
  {
    no: 14,
    document: 'Contracts Act 1950 (Act 136)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2006',
    status: 'Effective',
    notes: 'Effective',
    remarks: 'An Act relating to contracts.',
    preview:
      'https://drive.google.com/file/d/13FUaDFD4CfDIVc-jdopArIYtjSou2vZd/view?usp=sharing',
  },
  {
    no: 15,
    document: 'Employees Provident Fund Act 1991 (Act 452)',
    publisher: 'Attorney General’s Chambers of Malaysia',
    category: 'Legislative',
    edition: '2020',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to provide for the law relating to a scheme of savings for employees’ retirement and the management of the savings for the retirement purposes and for matters incidental thereto.',
    preview:
      'https://drive.google.com/file/d/1umcESTilDyLER98eIrckb5Z6khvpHGeN/view?usp=sharing',
  },
  {
    no: 16,
    document: 'Employees’ Social Security Act 1969 (Act 4)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2019',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to provide social security in certain contingencies and to make provision for certain other matters in relation to it.',
    preview:
      'https://drive.google.com/file/d/1guyUDThs424Uac0mGhGdgW_fQkAKUPyF/view?usp=sharing',
  },
  {
    no: 17,
    document: 'Employment Act 1955 (Act 265)',
    publisher: 'Attorney General’s Chambers of Malaysia',
    category: 'Legislative',
    edition: '2023',
    status: 'Effective',
    notes: 'Archived',
    remarks: 'An Act relating to employment.',
    preview:
      'https://drive.google.com/file/d/1gSUnPTZIuxLoBNb7ftqT6aSrCnsob2DD/view?usp=sharing',
  },
  {
    no: 18,
    document: 'Environmental Quality (Amendment) Act 2024 (Act A1712)',
    publisher: 'PNMB',
    category: 'Legislative',
    edition: '2024',
    status: 'Effective',
    notes: 'Archived',
    remarks: 'An Act to amend the Environmental Quality Act 1974.',
    preview:
      'https://drive.google.com/file/d/1MoYlm4JLARZ0usmZ4bHZ8k0xRv2ZYJih/view?usp=sharing',
  },
  {
    no: 19,
    document: 'Federal Constitution of Malaysia',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2020',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Serves as the supreme law of Malaysia, establishing the federal system, fundamental liberties, and the structure of government.',
    preview:
      'https://drive.google.com/file/d/1L4-SxBMAyEoGLgFSnEHf98kQ1EEvtFpE/view?usp=sharing',
  },
  {
    no: 20,
    document: 'Fire Services (Amendment) Act 2025 (Act A1764)',
    publisher: 'PNMB',
    category: 'Legislative',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks: 'An Act to amend the Fire Services Act 1988.',
    preview:
      'https://drive.google.com/file/d/126NMClc5svkoIDX_vELxexCxcqHEmQut/view?usp=sharing',
  },
  {
    no: 21,
    document: 'Fire Services Act 1988 (Act 341)',
    publisher: 'Attorney General’s Chambers of Malaysia',
    category: 'Legislative',
    edition: '2018',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to make necessary provision for the effective and efficient functioning of the Fire and Rescue Department, for the protection of persons and property from fire risks or emergencies and for purposes connected therewith.',
    preview:
      'https://drive.google.com/file/d/1I3fVDXaoiyT2kSnIcjGpY6Wt9WrdLCIj/view?usp=sharing',
  },
  {
    no: 22,
    document:
      'IEM Form of Contract for Civil Engineering Works - IEM CE 2011 2017',
    publisher: 'IEM',
    category: 'Forms of Contract',
    edition: '2017',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Provides standard civil engineering contract terms in Malaysia, detailing obligations, payments, and dispute resolution for smooth project execution.',
    preview:
      'https://drive.google.com/file/d/1ASU7--lD04nI_aJsswuxQvaCv1YGSAhN/view?usp=sharing',
  },
  {
    no: 23,
    document: 'Jadual Kadar Kerja Elektrik (JKKE) 2025 - JKR JKKE Eletrik 2025',
    publisher: 'PWD',
    category: 'Standard Rates',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Offers standardized rates for electrical works, ensuring consistency and fairness in pricing for public sector electrical projects.',
    preview:
      'https://drive.google.com/file/d/15kiwm507Qoxtj7i7XEXFWTUZJeKyvZiS/view?usp=sharing',
  },
  {
    no: 24,
    document: 'Jadual Kadar Kerja Kejuruteraan Awam dan Bangunan Tahun 2025',
    publisher: 'PWD',
    category: 'Standard Rates',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Provides standardized rates for civil and building works, aiding in budgeting and cost control for public sector projects.',
    preview:
      'https://drive.google.com/file/d/1j8YNYKlCKd2wIPKehuEYE4YAb6vvTEOd/view?usp=sharing',
  },
  {
    no: 25,
    document: 'JUBM & Arcadis Construction Cost Handbook Malaysia 2022',
    publisher: 'JUBM & Arcadis',
    category: 'Costbook',
    edition: '2022',
    status: 'Unspecified',
    notes: 'Archived',
    remarks:
      'This handbook provides detailed information on construction costs across various sectors in Malaysia, including residential, commercial, and industrial projects. It serves as a comprehensive resource for professionals in the construction industry, assisting in budgeting, planning, and cost estimation.',
    preview:
      'https://drive.google.com/file/d/1ebdaZ_lNsBtWH2U2WIrtaqCoq-8QmCo2/view?usp=sharing',
  },
  {
    no: 26,
    document: 'Limitation Act 1953 (Act 254)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2019',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to provide for the limitation of actions and arbitrations.',
    preview:
      'https://drive.google.com/file/d/1auMCePtlNCxJzVLxozho8wE_BPE_qX5B/view?usp=sharing',
  },
  {
    no: 27,
    document:
      'Malaysian Civil Engineering Standard Method of Measurement Second Edition - MyCESMM2',
    publisher: 'CIDB',
    category: 'Measurements',
    edition: '2018',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Establishes a unified measurement standard for civil engineering works, promoting transparency and consistency in cost estimation and contract management.',
    preview:
      'https://drive.google.com/file/d/1jqDkXqDqWy_2U6IIOuOkkhuVvwHqSNOs/view?usp=sharing',
  },
  {
    no: 28,
    document:
      'Malaysian Standard Method of Measurement of Building Works, Second Edition - SMM2',
    publisher: 'RISM',
    category: 'Measurements',
    edition: '2000',
    status: 'Effective',
    notes: 'Effective',
    remarks:
      'Provides standardized guidelines for measuring building works, ensuring consistency and accuracy in quantity surveying practices.',
    preview:
      'https://drive.google.com/file/d/1pCrjqpY7A11cF2mm2FQmbfHU9iPBx105/view?usp=sharing',
  },
  {
    no: 29,
    document:
      'Malaysian Standard Method of Measurement of Building Works, Third Edition - SMM3',
    publisher: 'RISM',
    category: 'Measurements',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Updates measurement standards to incorporate modern construction techniques and materials, facilitating accurate cost estimation and project planning.',
    preview:
      'https://drive.google.com/file/d/135T8N8QZj8BaslbwH343h-uRKTuaKOUO/view?usp=sharing',
  },
  {
    no: 30,
    document: 'Mediation Act 2012 (Act 749)',
    publisher: 'PNMB',
    category: 'Legislative',
    edition: '2012',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to promote and encourage mediation as a method of alternative dispute resolution by providing for the process of mediation, thereby facilitating the parties in disputes to settle disputes in a fair, speedy ad cos-effective manner and to provide for related matters.',
    preview:
      'https://drive.google.com/file/d/129FpZZyjAXSbACCTAp4-a4ZRMCYop3YR/view?usp=sharing',
  },
  {
    no: 31,
    document: 'National Construction Policy 2030 (NCP 2030)',
    publisher: 'MOW',
    category: 'Governance',
    edition: '2021',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      "Aims to transform Malaysia's construction sector towards digitalisation, enhancing international competitiveness and sustainability.",
    preview:
      'https://drive.google.com/file/d/1VxVFZqV5LLwMwakOY155J6U6UdwG22mV/view?usp=sharing',
  },
  {
    no: 32,
    document: 'National Heritage Act 2005 (Act 645)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2006',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to provide for the conservation and preservation of National Heritage, natural heritage, tangible and intangible cultural heritage, underwater cultural heritage, treasure trove and for related matters.',
    preview:
      'https://drive.google.com/file/d/1Mm-iIZgxtB_EjzCeRiJgLEaimHTGNe_8/view?usp=sharing',
  },
  {
    no: 33,
    document: 'National Land Code (Act 828)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2020',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to amend and consolidate the laws relating to land and land tenure, the registration of title to land and of dealings therewith and the collection of revenue therefrom within the States of Johore, Kedah, Kelantan, Malacca, Negeri Sembilan, Pahang, Penang, Perak, Perlis, Selangor, Terengganu and the Federal Territories of Kuala Lumpur, Putrajaya and Labuan and for purposes connected therewith.',
    preview:
      'https://drive.google.com/file/d/1zTFL7F5MizX7cgYuGuDCqAJQ6on6OmNS/view?usp=sharing',
  },
  {
    no: 34,
    document: 'Occupational Safety and Health Act 1994 (Act 514)',
    publisher: 'Attorney General’s Chambers of Malaysia',
    category: 'Legislative',
    edition: '2024',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to make further provisions for securing the safety, health and welfare of persons at work, for protecting others against risks to safety or health in connection with the activities of persons at work, to establish the National Council for Occupational Safety and Health, and for matters connected therewith.',
    preview:
      'https://drive.google.com/file/d/1kquHjzhgoEA-mxp8ObZ40o1Fzw5HrI42/view?usp=sharing',
  },
  {
    no: 35,
    document:
      'Pentadbiran Kontrak dan Format Perjanjian Piawai Perunding (PK 3.32013)',
    publisher: 'MOF',
    category: 'Treasury Circular',
    edition: '2013',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Provides standardized contract administration procedures and agreement formats for consultants, ensuring consistency and clarity in public sector engagements.',
    preview:
      'https://drive.google.com/file/d/1oTEpppmKdnnD-y47yh3mdasj6YA9sFeM/view?usp=sharing',
  },
  {
    no: 36,
    document: 'Quantity Surveyors (Amendment) Act 2015 (Act A1481)',
    publisher: 'BQSM',
    category: 'Legislative',
    edition: '2015',
    status: 'Effective',
    notes: 'Archived',
    remarks: 'An Act to amend the Quantity Surveyors Act 1967.',
    preview:
      'https://drive.google.com/file/d/1mVMH9ohwy5ZXO6PUlAzHElLUGplyIov6/view?usp=sharing',
  },
  {
    no: 37,
    document: 'Quantity Surveyors Act 1967 (Act 487)',
    publisher: 'BQSM',
    category: 'Legislative',
    edition: '2016',
    status: 'Effective',
    notes: 'Effective',
    remarks:
      'An Act to provide for the establishment of the Board of Quantity Surveyors, for the registration of Quantity Surveyors and approval to practise of firms or bodies corporate practising as consulting Quantity Surveyors, for the regulation of the practice of quantity surveying and for matters connected therewith.',
    preview:
      'https://drive.google.com/file/d/1ZioumyuefiGbSb3Oxoulqbtv5TQ9vn_j/view?usp=sharing',
  },
  {
    no: 38,
    document: 'Reciprocal Enforcement of Judgments Act 1958 (Act 99)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2006',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act for the reciprocal enforcement of judgments of superior courts.',
    preview:
      'https://drive.google.com/file/d/1JVkwADinflTBxNJmBkTL8o8PmhpAvMtP/view?usp=sharing',
  },
  {
    no: 39,
    document: 'Ringkasan Rancangan Malaysia Ke-13 (RMK13)',
    publisher: 'MOE',
    category: 'Governance',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      "Outlines Malaysia's development roadmap from 2026 to 2030, focusing on high and sustainable income, quality of life, and environmental sustainability.",
    preview:
      'https://drive.google.com/file/d/19vmzpID2lBjXPEzjjyDtEQcMcn3wFrpF/view?usp=sharing',
  },
  {
    no: 40,
    document: 'Sale of Goods Act 1957 (Act 382)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2006',
    status: 'Effective',
    notes: 'Archived',
    remarks: 'An Act relating to the sale of goods.',
    preview:
      'https://drive.google.com/file/d/1e1U7tGEW7ifCF2xyoZAAPWIoJy1TKGCH/view?usp=sharing',
  },
  {
    no: 41,
    document:
      'Specification for Occupational Safety and Health in Construction Works 2025',
    publisher: 'PWD',
    category: 'Standard Specification',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Sets out safety and health requirements for construction activities, aiming to reduce accidents and promote a safe working environment.',
    preview:
      'https://drive.google.com/file/d/13EOf8R3e3xNjxA6MyO-ATRKK2sQGigXY/view?usp=sharing',
  },
  {
    no: 42,
    document:
      'Standard Form of Building Contract (SFC) 2024 Edition - AIAC SFC Building Contract 2024',
    publisher: 'AIAC',
    category: 'Forms of Contract',
    edition: '2024',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Standard form for major building works, providing clear terms, timelines, and obligations to minimize disputes and support project management.',
    preview:
      'https://drive.google.com/file/d/1ytsBQ6cmR_o9424uk-SJ3MrSnQycdARF/view?usp=sharing',
  },
  {
    no: 43,
    document:
      'Standard Form of Contract for Nominated Sub-Contractor Where the Main Contract is Based Upon PWD Form 203 or 203A - PWD Form 203N (Rev. 1_2010)',
    publisher: 'PWD',
    category: 'Forms of Contract',
    edition: '2010',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'For nominated subcontractors under PWD contracts, ensuring clear responsibilities, obligations, and legal compliance.',
    preview:
      'https://drive.google.com/file/d/1rj4QBIoyUumVhmK8vDIJI9A0PmkhO-Bh/view?usp=sharing',
  },
  {
    no: 44,
    document:
      'Standard Form of Contract for Nominated Sub-Contractor Where the Main Contract is Based Upon PWD Form 203 or 203A - PWD Form 203N (Rev. 2007)',
    publisher: 'PWD',
    category: 'Forms of Contract',
    edition: '2007',
    status: 'Archived',
    notes: 'Archived',
    remarks:
      'For nominated subcontractors under PWD contracts, ensuring clear responsibilities, obligations, and legal compliance.',
    preview:
      'https://drive.google.com/file/d/1daYueTdXLV6L6NIanf62GWpxOqnr8rU3/view?usp=sharing',
  },
  {
    no: 45,
    document:
      'Standard Form of Contract for Nominated Suppliers Where The Main Contract is Based Upon PWD Form 203 or 203a – PWD Form 203P (Rev. 1_2010)',
    publisher: 'PWD',
    category: 'Forms of Contract',
    edition: '2010',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'For nominated suppliers under PWD contracts, detailing obligations, payments, and compliance with government regulations.',
    preview:
      'https://drive.google.com/file/d/1tXlfOPQ41WbEhDT8aICaF4bEVKyP5NRr/view?usp=sharing',
  },
  {
    no: 46,
    document:
      'Standard Form of Contract to be Used Where Bills of Quantities Form Part of the Contract - PWD FORM 203A (Rev. 1_2010)',
    publisher: 'PWD',
    category: 'Forms of Contract',
    edition: '2010',
    status: 'Effective',
    notes: 'Effective',
    remarks:
      'Government contract incorporating Bills of Quantities, clarifying obligations, payments, and responsibilities.',
    preview:
      'https://drive.google.com/file/d/1TZjQL3RtGX849wDnA6e1bpdiBCPB8GbI/view?usp=sharing',
  },
  {
    no: 47,
    document:
      'Standard Form of Contract to be used where Drawings and Specifications Form Part of the Contract - PWD FORM 203 (Rev. 1_2010)',
    publisher: 'PWD',
    category: 'Forms of Contract',
    edition: '2010',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Government contract based on drawings and specifications, defining obligations, roles, and payments for public projects.',
    preview:
      'https://drive.google.com/file/d/1zo6PEgH2UtQM4UPtbREZzSddbBiLKxph/view?usp=sharing',
  },
  {
    no: 48,
    document:
      'Standard Form of Design and Build Contract - PWD FORM DB (Rev. 1_2010)',
    publisher: 'PWD',
    category: 'Forms of Contract',
    edition: '2010',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Standard design-and-build contract for government projects, integrating design, construction, and responsibilities to ensure efficient delivery.',
    preview:
      'https://drive.google.com/file/d/1fBICq7MNAiCXEBSzVphTWKWlu2ormUlx/view?usp=sharing',
  },
  {
    no: 49,
    document:
      'Standard Specification for Road Works – Section 4: Flexible Pavement',
    publisher: 'PWD',
    category: 'Standard Specification',
    edition: '2008',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Provides technical specifications for the construction of flexible pavements, ensuring quality and durability in road infrastructure.',
    preview:
      'https://drive.google.com/file/d/1XwGm8VjhMPW6daJpkOYm5LrwE0TT5de0/view?usp=sharing',
  },
  {
    no: 50,
    document: 'Standard Specifications for Building Works 2025',
    publisher: 'PWD',
    category: 'Standard Specification',
    edition: '2025',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Outlines technical requirements for building construction, ensuring quality, safety, and compliance with regulations.',
    preview:
      'https://drive.google.com/file/d/1G7jOFSW0pejzxvHq1yLSgJ6SPYfiiUUg/view?usp=sharing',
  },
  {
    no: 51,
    document:
      'Standard Terms of Construction Contract for Renovation and Small Projects - CIDB STCC-RSP 2015',
    publisher: 'CIDB',
    category: 'Forms of Contract',
    edition: '2015',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'A plain-language contract designed to streamline agreements between clients and contractors for renovation and small-scale construction projects in Malaysia.',
    preview:
      'https://drive.google.com/file/d/1ef7fqwuN3P8Itsy8Id9n4-5UUPVdFKVp/view?usp=sharing',
  },
  {
    no: 52,
    document: 'Strata Titles Act 1985 (Act 318)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2006',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'An Act to facilitate the subdivision of building into parcels and the disposition of titles and for purposes connected therewith.',
    preview:
      'https://drive.google.com/file/d/17zIEhJk_kJvX_sfqVa348nvv6J8j8Qnh/view?usp=sharing',
  },
  {
    no: 53,
    document: 'Street, Drainage and Building Act 1974 (Act 133)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2014',
    status: 'Archived',
    notes: 'Archived',
    remarks:
      'An Act to amend and consolidate the laws relating to street, drainage and building in local authority areas in Peninsular Malaysia, and for purposes connected therewith.',
    preview:
      'https://drive.google.com/file/d/1ndCXYEcB5VCL0gr3x_6I9ARKPceyljIX/view?usp=sharing',
  },
  {
    no: 54,
    document:
      'The Standard Form of Building Sub-Contract 2019 Edition - AIAC SFC Sub-Contract 2019',
    publisher: 'AIAC',
    category: 'Forms of Contract',
    edition: '2019',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Governs subcontracting under AIAC projects, clarifying responsibilities, payments, and legal compliance to ensure smooth coordination between main and subcontractors.',
    preview:
      'https://drive.google.com/file/d/1nVTrj2mxIF3PBY6LJi6ELJ8UMQVYxNxs/view?usp=sharing',
  },
  {
    no: 55,
    document:
      'The Standard Form of Minor Works Building Contract 2018 Edition - AIAC SFC Minor Works 2018',
    publisher: 'AIAC',
    category: 'Forms of Contract',
    edition: '2018',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'Standard contract for minor building projects, defining parties’ roles, obligations, payments, and dispute resolution for efficient execution and risk management.',
    preview:
      'https://drive.google.com/file/d/1eCswGzg4eKkdVdSvumABh_VLB0hOuqd8/view?usp=sharing',
  },
  {
    no: 56,
    document: 'Uniform Building By-Laws 1984 (G.N. 5178/84)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2022',
    status: 'Effective',
    notes: 'Archived',
    remarks:
      'The UBBL serves as a model by-law under the Street, Drainage and Building Act 1974 (Act 133). Enforcement authority lies with individual state authorities, and each state may adopt and amend the by-laws as necessary.',
    preview:
      'https://drive.google.com/file/d/1-cieek-3apkQX_yqPfi7Iud1TzTXqX-F/view?usp=sharing',
  },
  {
    no: 57,
    document: 'Workmen’s Compensation Act 1952 (Act 273)',
    publisher: 'Commissioner of Law Revision',
    category: 'Legislative',
    edition: '2006',
    status: 'Archived',
    notes: 'Archived',
    remarks:
      'An Act to provide for the payment of compensation to workmen for injury suffered in the course of their employment. The Act is no longer applicable to Malaysian workers, who are now covered under the Employees Social Security Act 1969 (Act 4).',
    preview:
      'https://drive.google.com/file/d/1bIjT-Ctq40JttOo4zSmhz8MqagyckM9s/view?usp=sharing',
  },
];
